export class Labelling {
  readonly BackLabel = 'Back';
}
